import React from "react";

import Services from "../../../components/ServicesImgText";

import fabric from "../../../images/services/ServicesPage/fabric1.png"
const index = () => {
  return (
    <div>
      <Services
        title=">Expansion by 
        Pre-Fabricated Structure"
        heading="Expansion by 
        Pre-Fabricated Structure"
        text="Whether it is a house or a farmhouse, build rooms and living spaces that are open, comfortable and cozy.

        Our designed architecture structure is light in weight, beautiful in appearance, unique in durability and incomparable. Whether you need a living space or a extra storage, we will tailor the structure to your needs."
        Image={fabric}
      />
    </div>
  );
};

export default index;
